import { styled } from "@mui/material/styles";

export const SignUpContainer = styled("div")(({ theme }) => ({
  position: "relative",
  maxWidth: "450px",
  display: "flex",
  flexDirection: "column",
  margin: "50px auto",
  border: "#211F45 1px solid",
  background: "rgba(255,255,255,0.04)",
  boxShadow:
    "0px 12px 16px -4px rgba(0, 91, 140, 0.10),0px 4px 6px -2px rgba(0, 91, 140, 0.03),0px 2px 2px -1px rgba(0, 91, 140, 0.04)",
  borderRadius: "12px",
  padding: "24px",
  [theme.breakpoints.down("sm")]: {
    margin: "20px auto",
  },
  "& form": {
    width: "100%",
  },
  "& .signup-free-trial": {
    "& > div": {
      margin: "30px 0 0 0"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 20px",
    },
    "& h1": {
      fontSize: "clamp(1rem, 1rem + 2vw, 1.875rem)",
      fontWeight: 600,
      margin: "2rem 0 1rem 0",
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        margin: "1rem 0",
      },
    },
    "& > img": {
      width: "67px",
      margin: "0 auto",
      display: "flex",
    },
    "& > p": {
      margin: "0 0 2rem 0",
      textAlign: "center",
      fontWeight: "normal",
      opacity: 0.8,
    },
    "& .utils": {
      display: "flex",
      margin: "2rem 0",
      fontSize: "12px",
      justifyContent: "space-between",
      alignItems: "center",
      "& .checkboxes": {
        "& .input-field": {
          marginBottom: "15px",
          "&:last-child": {
            marginBottom: 0,
          },
          "& label": {
            marginBottom: 0,
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
          },
          "& input": {
            marginRight: "8px",
          },
        },
      },
      "& .forgot-link": {
        color: "#D1C7FF",
        textDecoration: "none",
      },
    },
    "& .input-field": {
      marginBottom: "1.2em",
      "& label": {
        fontSize: "14px",
        marginBottom: "5px",
        display: "inline-block",
      },
    },
    "& button": {
      display: "block",
      width: "100%",
      padding: "12px 20px",
      "& p": {
        fontSize: "16px",
      },
    },
    "& .help-text": {
      fontSize: "14px",
      color: "#D5D7DA",
      fontWeight: 400,
      fontStyle: "italic",
      marginTop: "10px",
    },
    "& .register-helper": {
      marginTop: "2rem",
      textAlign: "center",
      fontSize: "14px",
      "& a": {
        color: "#D1C7FF",
        textDecoration: "none",
      },
    },
  },
  "& .password-critiera": {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
    "& > div": {
      display: "flex",
      fontWeight: "400",
      gap: "10px",
      fontSize: "14px",
      "& .icon": {
        background: "#D1C7FF",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        textAlign: "center",
        "&.active": {
          background: "#CCFFCC",
        },
        "& svg": {
          width: "12px",
          height: "10px",
        },
      },
    },
  },
}));
